export const LOGIN_FORM_KEYS = {
  Email: 'email',
  Password: 'password',
  NewPassword: 'newPassword',
  ConfirmPassword: 'confirmNewPassword',
}

